"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Inquiry = exports.InquiryType = exports.InquiryCategory = void 0;
var InquiryCategory;
(function (InquiryCategory) {
    InquiryCategory["sponsor"] = "SPONSOR";
    InquiryCategory["cro"] = "CRO";
    InquiryCategory["site"] = "SITE";
    InquiryCategory["account"] = "ACCOUNT";
    InquiryCategory["study"] = "STUDY";
    InquiryCategory["edc"] = "EDC";
    InquiryCategory["etc"] = "ETC";
})(InquiryCategory = exports.InquiryCategory || (exports.InquiryCategory = {}));
var InquiryType;
(function (InquiryType) {
    InquiryType["study"] = "STUDY";
    InquiryType["system"] = "SYSTEM";
})(InquiryType = exports.InquiryType || (exports.InquiryType = {}));
class Inquiry {
}
exports.Inquiry = Inquiry;
//# sourceMappingURL=inquiry.js.map